export const ROOT_URL = process.env.REACT_APP_ROOT_URL;
export const SERVER_URL = process.env.REACT_APP_IITP_CONTEXT_URL; // REST API 서버 Domain URL
export const IMAGE_URL = SERVER_URL + "/cmm/fms/getImage?atchFileStr=";
export const DPAUTH_URL = process.env.REACT_APP_AUTH_CONTEXT_URL; // REST API 서버 Domain URL
export const IITP_OS_AT = process.env.REACT_APP_IITP_OS_MODE; // AFTERCARE 운영모드
export const DEV_MODE_AT = SERVER_URL.includes("localhost") || SERVER_URL.includes("dev-") || SERVER_URL.includes("172.30.1");
export const DPAUTH_APIKEY = process.env.REACT_APP_DPMSG_API_KEY;
export const KAKAO_REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY; // 카카오 rest api 고유 키
export const KAKAO_REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI; // 환경별 카카오 로그인 리다이렉트 uri
export const NAVER_REST_API_KEY = process.env.REACT_APP_NAVER_REST_API_KEY; // 네이버 rest api 고유 키
export const NAVER_REDIRECT_URI = process.env.REACT_APP_NAVER_REDIRECT_URI; // 환경별 네이버 로그인 리다이렉트 uri
export const GOOGLE_REST_API_KEY = process.env.REACT_APP_GOOGLE_REST_API_KEY; // 구글 rest api 고유 키
export const GOOGLE_API_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID; // 구글 클라이언트 id
export const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI; // 환경별 구글 로그인 리다이렉트 uri
export const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI; // 환경별 애플 로그인 리다이렉트 uri
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID; // 환경별 애플 로그인 리다이렉트 uri
export const DPMSG_APIKEY = process.env.REACT_APP_DPMSG_API_KEY;


const URL = {

  ERROR                    : "/error", // 에러페이지

  // Login
  MAIN                     : "/",
  ALLOW_ACCESS             : "/allow-access",
  LANDING                  : "/landing",
  LOGIN_MAIN               : "/login",
  PRESCRIPTION_CODE        : "/prescription-code",
  IDENTITY                 : "/identity",
  SIGN_UP                  : "/signup",
  FIND_ID                  : "/find-id",
  FIND_PASSWORD            : "/find-pw",
  AGREE_CONDITIONS         : "/agree-conditions",
  MEMBERSHIP_COMPLETE      : "/membership-complete",
  ACTIVITY_LEVEL_SELECT    : "/activitylevelSelect",  // 신체 활동량 선택

  MEMBERSHIP_FAILED      : "/membership-failed",

  // SNS
  KAKAO_REDIRECT              : "/oauth/kakao/callback", // 카카오 로그인 콜백 URL
  NAVER_REDIRECT              : "/oauth/naver/callback", // 네이버 로그인 콜백 URL
  GOOGLE_REDIRECT             : "/oauth/google/callback", // 구글 로그인 콜백 URL
  APPLE_REDIRECT              : "/oauth/apple/callback", // 애플 로그인 콜백 URL
  // Niceid
  NICE_REDIRECT              : "/nice/redirect", // 나이스 Redirect (오리지날)
  NICE_DPREDIRECT            : "/nice/dpredirect", // dp 나이스 Redirect (디팜전용)

  // 알림
  ALARM                    : "/alarm",

  // 앱 설정
  APP_SETTINGS             : "/settings",
  MYINFO_WRITE             : "/settings/myinfo/write",
  CHANGE_PASSWORD          : "/settings/change-password",
  MY_INFO_WITHDRAW         : "/settings/myinfo/withdraw", // 앱 설정 > 내 정보 수정 > 탈퇴하기
  SERVICE_POLICY           : "/settings/policy",          // 앱 설정 > 서비스 약관 및 정책
  SERVICE_POLICY_DETAIL    : "/settings/policy/detail",   // 앱 설정 > 서비스 약관 및 정책 > 상세보기
  APP_VERSION              : "/settings/version",         // 앱 설정 > 앱 버전 정보
  ALARM_INTENSITY          : "/settings/alarmintensity",  // 앱 설정 > 알림강도설정
  ACTIVITY_LEVEL_CHANGE    : "/settings/activitylevelchange",  // 앱 설정 > 신체 활동량 변경

  // 홈
  HOME_MAIN                : "/home-main",

  // 식단 관리
  FOOD_RECORD_MAIN         : "/food-record",
  FOOD_RECORD_ADD          : "/food-record/add",
  FOOD_RECORD_DETAIL       : "/food-record/detail",
  FOOD_PHOTO_CAPTURE       : "/food-record/capture",   // 식단 촬영 + 두잉랩 인식
  FOOD_ITEM_DETAIL         : "/food-record/item",
  FOOD_SEARCH              : "/food-record/search",
  FOOD_MANUAL_ADD          : "/food-record/manual-add",

  // 운동 기록
  EXERCISE_RECORD_MAIN     : "/exercise-record",
  EXERCISE_RECORD_ADD      : "/exercise-record/add",
  EXERCISE_RECORD_COMPLETE : "/exercise-record/complete",

  // 걸음수 기록
  STEPS_MAIN               : "/steps/main",         // 걸음수 메인
  STEPS_DASHBOARD          : "/steps/dashboard",    // 걸음수 기록 대시보드
  STEPS_RECORD_LIST        : "/steps/record-list",  // 걸음수 기록 리스트

  // 혈압 기록
  BLOOD_PRESSURE_RECORD    : "/blood-pressure/record",        // 혈압 기록 메인
  BLOOD_PRESSURE_WRITE     : "/blood-pressure/write",         // 혈압 기록 상세
  WATCH_BP_GUIDE           : "/blood-pressure/watch/guide",   // 워치 혈압 측정 가이드

  // 체질량 기록
  BODY_MASS_RECORD         : "/bodymass/record",   // 체질량 기록 메인
  BODY_MASS_WRITE          : "/bodymass/write",    // 체질량 기록 상세

  // 검사결과
  HEALTH_RESULTS           : "/health-results",

  // 리포트
  REPORT                   : "/report",

  // 건강정보
  HEALTH_INFORM            : "/health-info",
  HEALTH_INFORM_DETAIL     : "/health-info/detail",

  // 챗
  DIET_CHATBOT                  : "/chatbot/dite",
  EXERCISE_CHATBOT              : "/chatbot/exercise",
  CHATBOT                       : "/chatbot/service",

};

export default URL;
